import * as React from 'react';
import { cn } from '../../lib/utils';

/**
 * 폼 필드 그룹 프리미티브.
 * - Field: 라벨 + 컨트롤 한 쌍
 * - Fieldset: 제목(legend) + 반응형 그리드로 Field들을 묶는 섹션
 */

export const Field: React.FC<{
  label: string;
  htmlFor?: string;
  className?: string;
  children: React.ReactNode;
}> = ({ label, htmlFor, className, children }) => (
  <div className={cn('rounded-md border border-border bg-card p-2.5', className)}>
    <label
      htmlFor={htmlFor}
      className="mb-1 block text-xs font-semibold uppercase tracking-wide text-muted-foreground"
    >
      {label}
    </label>
    {children}
  </div>
);

export const Fieldset: React.FC<{
  legend: string;
  accent?: boolean;
  /** 그리드 최소 컬럼 폭(px). columns 지정 시 무시 */
  minColWidth?: number;
  /** 커스텀 grid-template-columns (예: '1fr 1fr') */
  columns?: string;
  className?: string;
  children: React.ReactNode;
}> = ({ legend, accent, minColWidth = 200, columns, className, children }) => (
  <fieldset
    className={cn(
      'm-0 rounded-lg border p-4',
      accent ? 'border-primary/30 bg-primary/5' : 'border-border bg-muted/30',
      className,
    )}
  >
    <legend
      className={cn(
        'px-2 text-xs font-bold uppercase tracking-wider',
        accent ? 'text-primary' : 'text-muted-foreground',
      )}
    >
      {legend}
    </legend>
    <div
      className="grid gap-3.5"
      style={{ gridTemplateColumns: columns ?? `repeat(auto-fill, minmax(${minColWidth}px, 1fr))` }}
    >
      {children}
    </div>
  </fieldset>
);
